// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  serverTimestamp,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyChwbG3QG1m4xukci6hxO6vztYdEtiDPPo",
  authDomain: "hadycomeducation.firebaseapp.com",
  projectId: "hadycomeducation",
  storageBucket: "hadycomeducation.appspot.com",
  messagingSenderId: "1020081643229",
  appId: "1:1020081643229:web:4bccbfd937f125bc804534",
};

/*
|--------------------------------------------------------------------------
| APPLICATION PRINCIPALE : CONSULTING / FINANCE
|--------------------------------------------------------------------------
|
| On conserve l'application Firebase par défaut afin de ne pas casser
| les imports actuels utilisant :
|
| import { auth } from "../firebase";
|
*/

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

/*
|--------------------------------------------------------------------------
| APPLICATION FIREBASE SÉPARÉE : ÉDUCATION
|--------------------------------------------------------------------------
|
| Cette seconde instance possède sa propre session d'authentification
| dans le navigateur.
|
| Ainsi, être connecté dans Consulting/Finance ne signifie plus
| automatiquement être connecté dans Éducation.
|
*/

const educationApp = initializeApp(
  firebaseConfig,
  "hdc-education"
);

export const educationAuth = getAuth(educationApp);
export const educationDb = getFirestore(educationApp);
export const educationStorage = getStorage(educationApp);

/*
|--------------------------------------------------------------------------
| OUTILS FIRESTORE
|--------------------------------------------------------------------------
*/

export { serverTimestamp };

/*
|--------------------------------------------------------------------------
| EXPORT PAR DÉFAUT
|--------------------------------------------------------------------------
*/

export default app;